export const subscriptionFragment = `
  id
  createdAt
  intervalInDays
  nextTriggerAt
  priceInCents
  customer {
    id
    firstname
    lastname
  }
  items {
    id
    quantity
    productVariant {
      id
      sku
      product {
        id
        name
      }
    }
  }
  status
  priceInCents
`
